import { GridApi } from '@ag-grid-community/core';
import { Subscription } from '@urc-ui/store/api/subscriptions/types';
import { TAKT_EVENT_SOURCE } from '@urc-ui/hooks/takt-logger';

export interface ActionsProps {
  readonly gridApi: GridApi;
  readonly source: ActionSource;
  readonly subscription?: Subscription;
  readonly subscriptionId?: string;
  readonly taktEventSource: TAKT_EVENT_SOURCE;
}

export enum ActionSource {
  SUBSCRIPTION_TABLE = 'SUBSCRIPTION_TABLE',
  VIEW_SUBSCRIPTION_CONSOLE_HEADER = 'VIEW_SUBSCRIPTION_CONSOLE_HEADER'
}
